import React from 'react';
import { styles } from './QuickSearch.css';
import { SearchIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Search';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export interface QuickSearchProps {
  placeholder?: string;
  className?: string;
}

export const QuickSearch = ({ placeholder, className }: QuickSearchProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.searchBox} id="quicksearch-search-box" data-testid="quicksearch-search-box">
        <SearchIcon className={styles.icon} />
        <input placeholder={placeholder} className={styles.searchInput} />
      </div>
    </div>
  );
};
